import { Placeholder } from 'semantic-ui-react'

import { SidebarHeader } from './Styles'

const EmployeeSidebarPlaceholder = () => (
  <SidebarHeader>
    <Placeholder>
      <Placeholder.Header>
        <Placeholder.Line />
      </Placeholder.Header>
    </Placeholder>

    <Placeholder>
      <Placeholder.Line />
      <Placeholder.Line />
    </Placeholder>

    <Placeholder>
      <Placeholder.Image square />
    </Placeholder>

    <Placeholder>
      <Placeholder.Header>
        {new Array(9).fill(0).map((_, i) => (
          <Placeholder.Line
            key={i}
            length="full"
            style={{ margin: '10px 0', height: '25px' }}
          />
        ))}
      </Placeholder.Header>
    </Placeholder>
  </SidebarHeader>
)

export default EmployeeSidebarPlaceholder
